const INITIAL_STATE = {
  order: null
}

export const Creators = {
  setOrders: (data) => ({
    type: 'SET_ORDER',
    order: data,
  }),
};

export default function logisticPaymentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_ORDER_PAYMENT':
      return {
        ...state,
        order: action.order
      }
    case 'RESET':
      return {
        order: null
      }
    default:
      return state;
  }
}
